/**
 * NGTAssetLocator.js
 * 
 * Created on Sep 27, 2013, 5:32:15 PM
 *
 * @author Javier Quevedo-Fernandez for Ranj
 **/
import Config from "../../core/config/Config";
import LanguageModel from "../../core/language/model/LanguageModel";
import ContentTypes from "/lib/html5-software-library/src/ranj/eng/content/ContentTypes";
import { isNull } from "/lib/html5-software-library/src/ranj/util/TypeUtil";

export default class NGTAssetLocator {
    /**
     * 
     * @param {Config} config 
     * @param {LanguageModel} languageModel 
     */
    constructor(config, languageModel) {
        this._config = config;
        this._languageModel = languageModel;
    }

    getLocationForContent(content, scenarioID) {
        var type = content.getType();
        switch (type) {
            case (ContentTypes.TYPE_AUDIO):
                return this.getAudioLocationForID(content.getAudio(), scenarioID);
            case (ContentTypes.TYPE_MOVIE):
                return this.getVideoLocationsForID(content.getMovie(), scenarioID);
            case (ContentTypes.TYPE_IMAGE):
                // Lazy load
                return this.getAssetLocationForID(content.getImage());
            default:
                return null;
        }
    };

    getVideoLocationsForID(videoID, scenarioID) {
        if (this._config.getValue("settings.useHLS")) {
            return `assets/scenarios/${scenarioID}/movie/hls/${videoID}/${videoID}.m3u8`;
        } else {
            return 'assets/scenarios/' + scenarioID + '/movie/' + videoID + '.mp4';
        }
    };

    getSubtitleLocationForID(content, scenarioID) {
        return `assets.localized/${this._languageModel.currentLanguage}/scenarios/${scenarioID}/movie/subtitles/${content.getMovie()}.vtt`;
    };

    getAudioLocationForID(audioID, scenarioID) {
        // We dont neeed to include the audio extensions, the sound manager will do this based on the browser and format required        
        if (!isNull(scenarioID)) {
            // If the sounds are specific for an scenario they should be placed in the senarios audio folder
            return 'assets/scenarios/' + scenarioID + '/audio/' + audioID + ".mp3";
        } else {
            // If the sounds are not scenario specific they should be placed in the asset/sounds folder
            return 'assets/sounds/' + audioID + ".mp3";
        }
    };

    addManifest(manifest) {
        if (isNull(manifest)) return;
        if (isNull(this.assetLocations)) this.assetLocations = {};

        for (var i = 0; i < manifest.length; i++) {
            var manifestEntry = manifest[i];
            this.assetLocations[manifestEntry.id] = manifestEntry;
        }
    };

    getAssetLocationForID(assetID) {
        var manifestEntry = this.assetLocations[assetID];
        if (!isNull(manifestEntry)) {
            return manifestEntry.src;
        }
        return null;
    };

}